var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileNavToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 22.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35055"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 20.5)",
    fill: "#11385a",
    fontSize: 10,
    fontFamily: "Apparat-Medium, Apparat",
    fontWeight: 500,
    letterSpacing: ".01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MENU")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35057",
    fill: "none",
    stroke: "#11385a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 167",
    d: "M0 8.5h31"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 168",
    d: "M0 4.5h31"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 169",
    d: "M0 .5h31"
  })))));
}

export default SvgMobileNavToggle;